import React, {useContext} from "react";
import { Paging } from "@elastic/react-search-ui";
import RCPagination from "rc-pagination";
import { appendClassName } from "../../../../helpers/view-helpers";
import { useTranslation } from "react-i18next";
import ResultSelectContext from "../../../providers/ResultSelectContext";

const OmronPagination = () => {
  const { t } = useTranslation();
  const {resetAllSelected} = useContext(ResultSelectContext);
  const textItemRender = (current, type, element) => {
    if (type === "prev") {
      return t("prev");
    }
    if (type === "next") {
      return t("next");
    }
    if (type === "jump-prev") {
      return;
    }
    if (type === "jump-next") {
      return;
    }
    return element;
  };
  return (
    <Paging
      view={({ current, resultsPerPage, onChange, totalPages }) => {
        return (
          <RCPagination
            current={current}
            showTitle={false}
            onChange={(...e) => {
              onChange(...e);
              resetAllSelected();
            }}
            itemRender={textItemRender}
            pageSize={resultsPerPage}
            className={appendClassName("c-pager", "sui-paging")}
            total={totalPages * resultsPerPage}
          />
        );
      }}
    />
  );
};

export default OmronPagination;
